import {
  GetAllUserGroupsInput,
  GetAllUserGroupResponseSchema,
  UpdateUserGroup,
} from "shared";
import { axiosClient } from "utilz";
import {
  apiErrorHandler,
  generateUrlString,
  getMspId,
  getQueryDataObject,
} from "utilz/helpers";

export const getAllUserGroups = async ({
  perPageCount,
  pageNumber,
  sortColumn,
  sortDirection = "asc",
  filter,
  searchQuery,
  customerId,
}: GetAllUserGroupsInput) => {
  try {
    const data = await getQueryDataObject({
      perPageCount,
      pageNumber,
      sortColumn,
      sortDirection,
      filter,
      searchQuery,
    });
    const url = await generateUrlString({
      baseUrl: `/v2/customers/${customerId}/groups`,
      data,
    });
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      const result = GetAllUserGroupResponseSchema.parse(resData.data);
      return result;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

//add customer groups
export const addUserGroups = async ({
  customerIdParams,
  data,
}: {
  customerIdParams: any;
  data: any;
}) => {
  try {
    const url = `/create/customer_group/${customerIdParams}/${getMspId()}`;
    const response = await axiosClient.post(url, data);
    const responseData = response.data;
    if (responseData.success && responseData.statusCode === 200) {
      return responseData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

//update customer groups
export const updateUserGroups = async ({
  groupId,
  customerId,
  data,
}: UpdateUserGroup) => {
  try {
    const url = await generateUrlString({
      baseUrl: `/v2/groups/${groupId}/users`,
      data: {
        customer_id: customerId,
      },
    });
    const response = await axiosClient.patch(url, data);
    const responseData = response.data;
    if (responseData.success && responseData.statusCode === 200) {
      return responseData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

//delete customer groups
export const deleteUserGroups = async ({
  customerIdParams,
  groupIds,
}: {
  customerIdParams: any;
  groupIds: any;
}) => {
  try {
    // const url = `/delete/user/customer_group/${customerIdParams}`;
    const url = `/v2/customers/${customerIdParams}/groups/users`;
    const response = await axiosClient.patch(url, groupIds);
    const responseData = response.data;
    if (responseData.success && responseData.statusCode === 200) {
      return responseData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
